module.exports = __webpack_public_path__ + "img/swift-gls-blanco-pop.61619bd7.png";